import React from "react";
import { Table } from "antd";
import { Form } from "react-final-form";
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";

const SaveSelectedHierarchyModal = ({
  isOpenHierarchyList,
  toggleHierarchyList,
  onSubmitHierarchyList,
  columnsHierarchyList,
  hierarchyListData,
  promptText = "Please select the programs that you wish to update or add this event to",
}) => {
  return (
    <>
      <Modal
        className={`modal-event-hierarchy-list modal-lg`}
        isOpen={isOpenHierarchyList}
        toggle={toggleHierarchyList}
      >
        <ModalHeader>
          <div>{promptText}</div>
        </ModalHeader>
        <ModalBody className="modal-lg" style={{ textAlign: "left" }}>
          <Form onSubmit={onSubmitHierarchyList}>
            {({ handleSubmit }) => (
              <>
                <form className="form" onSubmit={handleSubmit}>
                  <div style={{ padding: "10px" }}>
                    <Button
                      outline
                      className="btn btn-primary btn-sm"
                      color="#ffffff"
                    >
                      Save
                    </Button>
                  </div>

                  <Table
                    pagination={false}
                    rowKey="id"
                    columns={columnsHierarchyList}
                    dataSource={hierarchyListData}
                  />
                </form>
              </>
            )}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};

export default SaveSelectedHierarchyModal;
